export default __webpack_public_path__ + "static/media/907.d6b81f35.png";